module.exports = __webpack_public_path__ + "img/login_oval_left.b3bafd52.png";